export default "__VITE_ASSET__njiHhKV5__"